module.exports = __webpack_public_path__ + "static/img/5.2bd1c5b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/sp/5.png
// module id = 2/kt
// module chunks = 0